// This file is generated by pnpm icons:generate. Do not edit.

import {CodeBrackets_Stroke2_Corner0_Rounded as CanonicalCodeBrackets_Stroke2_Corner0_Rounded} from './Code'
import {CodeBrackets_Stroke2_Corner2_Rounded as CanonicalCodeBrackets_Stroke2_Corner2_Rounded} from './Code'

/** @deprecated Import CodeBrackets_Stroke2_Corner0_Rounded from `#/components/icons/Code` instead. */
export const CodeBrackets_Stroke2_Corner0_Rounded =
  CanonicalCodeBrackets_Stroke2_Corner0_Rounded

/** @deprecated Import CodeBrackets_Stroke2_Corner2_Rounded from `#/components/icons/Code` instead. */
export const CodeBrackets_Stroke2_Corner2_Rounded =
  CanonicalCodeBrackets_Stroke2_Corner2_Rounded
